<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <BannerNotification />
    <CategoryUpdatePageHeader
      :categoryName="categoryName"
      :handleUpdate="handleUpdateCategoryInstance"
    />
    <CategoryForm
      :categoryName="categoryName"
      :formData="updateFormData"
      :componentId="componentId"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import CategoryUpdatePageHeader from "@/components/ComponentModule/CategoryComponent/CategoryUpdatePageHeader";
import CategoryForm from "@/components/ComponentModule/CategoryComponent/CategoryForm";

export default {
  name: "CategoryUpdatePage",
  components: {
    CategoryUpdatePageHeader,
    BannerNotification,
    CategoryForm
  },
  data() {
    return {
      updateFormData: {
        category_page: {
          attributes: {
            abi_cat_content_block: "yes",
            abi_cat_content_block_instance: "abi_content_block",
            abi_cat_tagline: "",
            abi_cat_desc: "yes",
            abi_cat_desc_faqs: "yes",
            abi_cat_desc_range: "yes",
            abi_cat_desc_overview: "yes",
            abi_cat_desc_assistance: "yes",
            abi_cat_ribbon_custom: "no",
            abi_cat_ribbon_arr: ""
          },
          instance_name: "",
          id: ""
        },
        abi_content_block: { attributes: {}, instance_name: "", id: "" },
        overview_ctb: { attributes: {}, instance_name: "", id: "" },
        range_ctb: { attributes: {}, instance_name: "", id: "" },
        assistance_ctb: { attributes: {}, instance_name: "", id: "" },
        faqs_ctb: { attributes: {}, instance_name: "", id: "" },
        category_faq: { attributes: {}, instance_name: "", id: "" }
      }
    };
  },
  props: {
    categoryName: {
      type: String,
      required: true
    }
  },
  mounted() {
    // fetch category name info
    if (!this.getAllComponent.length) {
      this.$store.dispatch(Actions.FETCH_ALL_COMPONENT, {
        region: this.getRegion,
        hardRefresh: false
      });
    } else {
      if (!Object.keys(this.categoryAllAttributes).length) {
        this.$store.dispatch(Actions.FETCH_CATEGORY_ATTRIBUTES, {
          region: this.getRegion,
          componentId: this.componentId
        });
      }
    }

    // fetch the category instance
    this.fetchInstance();
  },
  computed: {
    componentId() {
      const component = this.getAllComponent.find(
        (item) => item.name === "abi_category"
      );
      return component ? component.id : null;
    },
    ...mapGetters([
      "getAllComponent",
      "categoryInstance",
      "categoryAllAttributes",
      "getRegion",
      "currentUser"
    ])
  },
  watch: {
    componentId() {
      if (this.componentId) {
        this.$store.dispatch(Actions.FETCH_CATEGORY_ATTRIBUTES, {
          region: this.getRegion,
          componentId: this.componentId
        });
      }
    }
  },
  methods: {
    async handleUpdateCategoryInstance() {
      this.$store.dispatch(Actions.UPDATE_CATEGORY_INSTANCE, {
        region: this.getRegion,
        formData: this.updateFormData,
        user: this.currentUser.email
      });
    },
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    },
    resetUpdateForm() {
      // reset update form as default value
      this.updateFormData = {
        category_page: {
          attributes: {
            abi_cat_content_block: "",
            abi_cat_tagline: "",
            abi_cat_desc: "yes",
            abi_cat_desc_faqs: "yes",
            abi_cat_desc_range: "yes",
            abi_cat_desc_overview: "yes",
            abi_cat_desc_assistance: "yes",
            abi_cat_ribbon_custom: "no",
            abi_cat_ribbon_arr: ""
          },
          instance_name: "",
          id: ""
        },
        abi_content_block: { attributes: {}, instance_name: "", id: "" },
        overview_ctb: { attributes: {}, instance_name: "", id: "" },
        range_ctb: { attributes: {}, instance_name: "", id: "" },
        assistance_ctb: { attributes: {}, instance_name: "", id: "" },
        faqs_ctb: { attributes: {}, instance_name: "", id: "" },
        category_faq: { attributes: {}, instance_name: "", id: "" }
      };
    },
    fetchInstance() {
      // clear previous form data
      this.resetUpdateForm();
      // fill in form data with instance value
      this.$store
        .dispatch(Actions.FETCH_CATEGORY_INSTANCE, {
          region: this.getRegion,
          categoryName: this.categoryName
        })
        .then(() => {
          if (this.categoryInstance && Array.isArray(this.categoryInstance)) {
            this.categoryInstance.forEach((item) => {
              if (
                item.instance_name.split("|")[0] ===
                this.getComponentId("abi_category")
              ) {
                this.updateFormData["category_page"] = item;
                this.updateFormData["category_page"]["attributes"] =
                  item["attributes"];
              } else if (
                item.instance_name.split("|")[0] ===
                this.getComponentId("abi_category_faq")
              ) {
                this.updateFormData["category_faq"] = item;
              } else {
                let type = item.instance_name
                  .split("|")[1]
                  .replace(`_${this.categoryName}`, "");
                this.updateFormData[`${type}_ctb`] = item;
              }
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching category instance:", error);
        });
    }
  }
};
</script>
